import {
    FormControlLabel,
    Radio,
    RadioGroup,
    FormControl,
    Grid,
} from "@mui/material";
import { red, orange, cyan } from "@mui/material/colors";
import SquareSharpIcon from "@mui/icons-material/SquareSharp";
import CropSquareSharpIcon from "@mui/icons-material/CropSquareSharp";
import FormLabel from "@mui/material/FormLabel";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import { useState } from "react";
import IconButton from '@mui/material/IconButton';
import { useEffect } from "react";

const CustomTriStateCheckbox = (props) => {
    const [value, setValue] = useState(props.value);

    useEffect(() => {
        setValue(props.value)
    }, [props.value]);

    useEffect(() => {
        props.setValue(value)
    }, [value]);

    let textColSx =
    props.textColSx != null
      ? props.inputColSx
      : {
          display: "flex",
          alignItems: "center",
          justifyContent: "left",
          p: 1,
        };

    let inputColSx = props.inputColSx != null ? props.inputColSx : { p: 1 };

    return (
        <Grid container>
            <Grid
                item
                sm={props.textCol}
                sx={textColSx}
            >
                <FormLabel className={props.classLabel} htmlFor={props.id}>
                    {props.labelText}
                </FormLabel>
            </Grid>
            <Grid item sm={props.inputCol} display="flex" sx={inputColSx}>
                {value == null ? <IconButton onClick={() => {
                    setValue(true);
                }}>
                    <IndeterminateCheckBoxIcon color={props.iconColor}/>
                </IconButton> : (value === true ? <IconButton onClick={() => {
                    setValue(false);
                }}>
                    <CheckBoxIcon color={props.iconColor}/>
                </IconButton>
                    : <IconButton onClick={() => {
                        setValue(null);
                    }}>
                        <CheckBoxOutlineBlankIcon/>
                    </IconButton>
                )}

            </Grid>
        </Grid>
    );
};

export default CustomTriStateCheckbox;
